import { getBeneficiaries, register, getPendingRequest, 
  uploadFile, cancelRequest, getUploadedDocumentRequest, getAllRequest,
  acceptRequest, rejectRequest } from "@/api/beneficiarie";

export default class Beneficiaries {
  constructor() {

  }

  update = () => {

  }

  getBy = ({token_auth, rfc, name, middle_name, paternal_name, maternal_name}) => {
    return getBeneficiaries({token_auth, rfc, name, middle_name, paternal_name, maternal_name}).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  register = ({token_auth, rfc, name, middle_name, paternal_name, maternal_name, tutor, email, beneficiaries_list_json}) => {
    return register({token_auth, rfc, name, middle_name, paternal_name, maternal_name, tutor, email, beneficiaries_list_json}).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.response.message;
    });
  }

  getPendingRequest = (token_auth, rfc) => {
    return getPendingRequest(token_auth, rfc).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  uploadFile = (token_auth, beneficiary_update_request_id, file) => {
    return uploadFile(token_auth, beneficiary_update_request_id, file).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  cancelRequest = (token_auth, id) => {
    return cancelRequest(token_auth, id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  acceptRequest = (token_auth, id) => {
    return acceptRequest(token_auth, id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  rejectRequest = (token_auth, id) => {
    return rejectRequest(token_auth, id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  getUploadedDocumentRequest = (token_auth, rfc) => {
    return getUploadedDocumentRequest(token_auth, rfc).then(response => {
      return response
    }).catch(error => {
      throw error;
    })
  }

  getAllRequest = (token_auth) => {
    return getAllRequest(token_auth).then(response => {
      return response
    }).catch(error => {
      throw error;
    })
  }

  beneficiarieAlreadyExist(listBeneficiaries, newBeneficiarie) {
    let index = -1;

    if (listBeneficiaries.length > 0) {
      index = listBeneficiaries.findIndex(a => 
        a.paterno == newBeneficiarie.paterno && 
        a.materno == newBeneficiarie.materno &&
        a.nombre == newBeneficiarie.nombre &&
        a.fecha_nacimiento == newBeneficiarie.fecha_nacimiento
      )
    }

    return {
      exist: index != -1 ? true : false,
      id: index != -1 ? listBeneficiaries[index].id : index
    };
  }
}